"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAccountValidationSchema = exports.CreateAccountValidationSchema = void 0;
const cpf_1 = require("./helpers/cpf");
const Yup = __importStar(require("yup"));
const REQUIRED_FIELD = 'Este campo é obrigatório';
exports.CreateAccountValidationSchema = Yup.object({
    company: Yup
        .string()
        .required(REQUIRED_FIELD),
    holder_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    holder_email: Yup
        .string()
        .email('Deve ser um e-mail válido')
        .required(REQUIRED_FIELD),
    holder_cpf: Yup.string().test({
        test: cpf_1.CPF_TEST,
        message: 'Deve ser um CPF válido',
    }).required(),
    login: Yup.string().required(REQUIRED_FIELD),
    holder_phone_number: Yup.string().required(REQUIRED_FIELD),
    password: Yup.string().required(REQUIRED_FIELD),
    secondary_password: Yup.string().optional(),
});
exports.UpdateAccountValidationSchema = Yup.object({
    holder_name: Yup
        .string()
        .required(REQUIRED_FIELD),
    holder_email: Yup
        .string()
        .email('Deve ser um e-mail válido')
        .required(REQUIRED_FIELD),
    holder_cpf: Yup.string().test({
        test: cpf_1.CPF_TEST,
        message: 'Deve ser um CPF válido',
    }).required(),
    login: Yup.string().required(REQUIRED_FIELD),
    holder_phone_number: Yup.string().required(REQUIRED_FIELD),
    password: Yup.string().optional(),
    secondary_password: Yup.string().optional(),
});
